import type { Persona } from '../model/types';
import { i18n } from '@/shared/i18n';

export interface PersonaOption {
  id: string;
  label: string;
  photoAssetId?: string;
}

export function mapPersonasToOptions(personas: Persona[]): PersonaOption[] {
  return personas.map((persona) => {
    const unknown = i18n.t('common:components.sidePanel.unknown');
    const segmentName = 'segmentName' in persona ? (persona.segmentName ?? unknown) : unknown;
    const photoAssetId = 'photoAssetId' in persona ? persona.photoAssetId : undefined;

    return {
      id: persona.id,
      label: segmentName,
      photoAssetId: photoAssetId ?? undefined,
    };
  });
}
